import React from 'react';
import { motion } from 'framer-motion';
export function Reviews() {
  const reviews = [{
    text: 'Antes tardaba tres horas armando cada clase. Ahora tengo todo estructurado y mis alumnos avanzan el doble de rápido.',
    author: 'Valentina R.',
    role: 'Profesora de LSA',
    location: 'Buenos Aires'
  }, {
    text: 'Recién arrancaba como profe y no sabía por dónde empezar. Este sistema me dio la estructura que necesitaba desde el día uno.',
    author: 'Martín G.',
    role: 'Profesor de LSA',
    location: 'Córdoba'
  }, {
    text: 'Tengo años dando clases pero nunca había tenido el material tan ordenado. Mis alumnos lo notan y yo disfruto mucho más de enseñar.',
    author: 'Claudia P.',
    role: 'Profesora de LSA',
    location: 'Rosario'
  }];
  return <section className="bg-white text-lsa-dark py-10 px-5" data-id="element-251">
      <div className="max-w-xl mx-auto" data-id="element-252">
        <h2 className="text-xl font-bold text-center mb-8" data-id="element-253">
          Lo que dicen profesores que ya lo tienen
        </h2>

        <div className="flex flex-col gap-4" data-id="element-254">
          {reviews.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-lsa-light p-5 rounded-2xl border border-lsa-celeste/20 shadow-sm" data-id="element-255">
              <div className="text-lsa-celeste mb-2 text-lg tracking-widest" data-id="element-256">
                ★★★★★
              </div>
              <p className="italic text-[15px] leading-relaxed mb-4 text-lsa-dark/90" data-id="element-257">
                "{review.text}"
              </p>
              <div className="text-sm font-semibold text-lsa-dark" data-id="element-258">
                — {review.author}{' '}
                <span className="text-lsa-dark/50 font-normal" data-id="element-259">
                  · {review.role} · {review.location}
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}